"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDpIllustration = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDpIllustration = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .illustration-no-items {\n    text-align: center;\n    margin-top: ", ";\n    background-color: ", ";\n\n    button {\n      height: 40px;\n      width: 97px;\n      background: #091d27;\n    }\n\n    img {\n      margin-top: ", ";\n    }\n\n    .h3 {\n      padding-top: ", ";\n      font-weight: 600;\n    }\n\n    div {\n      color: ", ";\n    }\n\n    .spinner {\n      height: 45vh;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n    }\n  }\n"], ["\n  .illustration-no-items {\n    text-align: center;\n    margin-top: ", ";\n    background-color: ", ";\n\n    button {\n      height: 40px;\n      width: 97px;\n      background: #091d27;\n    }\n\n    img {\n      margin-top: ", ";\n    }\n\n    .h3 {\n      padding-top: ", ";\n      font-weight: 600;\n    }\n\n    div {\n      color: ", ";\n    }\n\n    .spinner {\n      height: 45vh;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n    }\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x5;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x6;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
});
var templateObject_1;
